<template>
  <div class="lang-switcher">
    <router-link
      :to="{ params: { lang: nextLocale() }, query: { ...$route.query } }"
      v-for="locale in locales"
      :key="locale"
      :class="[
        'lang-switcher__item',
        { active: $route.params.lang === locale },
      ]"
      >{{ content[locale] }}</router-link
    >
  </div>
</template>
<script setup>
import { useI18n } from "vue-i18n";

defineProps({
  content: Object,
});

const i18n = useI18n();
const locales = i18n.availableLocales.reverse();

function nextLocale() {
  const currentLocaleIndex = locales.findIndex((e) => {
    return e == i18n.locale.value;
  });

  const nextLocaleIndex =
    currentLocaleIndex < locales.length - 1 ? currentLocaleIndex + 1 : 0;

  return locales[nextLocaleIndex];
}
</script>

<style lang="scss" scoped>
.lang-switcher {
  height: fit-content;
  &__item {
    @include link-s;
    color: $scala-grigi-gray_1;
    opacity: 0.8;
    position: relative;
    transition: opacity 0.3s linear;

    &:hover {
      opacity: 1;
    }

    &::before {
      content: "";
      position: absolute;
      bottom: -5px;
      height: 2px;
      width: 100%;
      opacity: 0;
      transition: opacity 0.3s linear;
      background-color: $scala-grigi-gray_1;
    }

    &.active {
      opacity: 1;

      &::before {
        opacity: 1;
      }
    }

    &:not(:first-child) {
      margin-left: toRem(5);
    }
  }
}

.mobile {
  .lang-switcher {
    width: fit-content;
  }
}
</style>
